import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  selectOrganization: {
    id: 'organizations.select.header',
    defaultMessage: 'Choose an organization',
  },
  searchPlaceholder: {
    id: 'organizations.search.placeholder',
    defaultMessage: 'Search organization',
  },
  noOrganizations: {
    id: 'organizations.no.organizations',
    defaultMessage: 'No organizations found',
  },
  noMembershipTitle: {
    id: 'organizations.no.membership.title',
    defaultMessage: 'You are not part of any organization',
  },
  noMembershipText: {
    id: 'organizations.no.membership.text',
    defaultMessage: 'Your account is not a member of any organization. Please contact your administrator to get access.',
  },
  contactSupport: {
    id: 'organizations.no.membership.contactSupport',
    defaultMessage: 'Contact support',
  },
  logout: {
    id: 'organizations.no.membership.logout',
    defaultMessage: 'Log out',
  },
  noMatchingOrganization: {
    id: 'organizations.no.matching.organization',
    defaultMessage: 'You are not enrolled in the organization "{orgName}". Please choose another organization.',
  },
  paginationLabel: {
    id: 'organizations.pagination.label',
    defaultMessage: 'organization pagination',
    description: 'Accessible label for the organization list pagination control',
  },
  paginationPage: {
    id: 'organizations.pagination.page',
    defaultMessage: 'Page',
    description: 'Pagination button label for a page number',
  },
  paginationCurrentPage: {
    id: 'organizations.pagination.currentPage',
    defaultMessage: 'Current Page',
    description: 'Pagination button label for the currently selected page',
  },
  paginationPageOfCount: {
    id: 'organizations.pagination.pageOfCount',
    defaultMessage: 'of',
    description: 'Pagination separator between page number and total count',
  },
});

export default messages;
